import { SEARCH_PROVIDER_QUERY_PARAM } from './search-provider-preference';

/**
 * URL query keys that control app behaviour but are not job index facets.
 * Must not be mapped into refinementList / Typesense filter_by.
 */
export const SRP_NON_FILTER_QUERY_PARAMS = new Set<string>([
  SEARCH_PROVIDER_QUERY_PARAM,
  // SRP card + job detail page redesign A/B test QA override, see server/vike-handler.ts and
  // utils/analytics/card-design-variant.ts — must never be treated as a search facet.
  // Lowercase: isSrpNonFilterQueryParam() below normalizes lookups to lowercase before checking.
  'carddesign',
]);

export function isSrpNonFilterQueryParam(paramKey: string): boolean {
  const normalized = paramKey.replace(/^\uFEFF/, '').trim().toLowerCase();
  return SRP_NON_FILTER_QUERY_PARAMS.has(normalized);
}
